/* ART PRINT PICKER, collapsible carousel (2026-10-05). Markup: snippets/ss-print-carousel.liquid.
   Selection, ATC gating and the zoom viewer stay in ss-pdp-letter.js; this file only
   opens/closes the panel, mirrors the pick into the toggle row and drives the arrows. */
(function () {
  function init(car) {
    if (car.dataset.sspReady) return;
    car.dataset.sspReady = '1';
    var toggle = car.querySelector('[data-ssp-toggle]');
    var panel = car.querySelector('[data-ssp-panel]');
    var rail = car.querySelector('[data-ssp-rail]');
    if (!rail) return;
    var stack = car.querySelector('[data-ssp-stack]');
    var thumb = car.querySelector('[data-ssp-thumb]');
    var title = car.querySelector('[data-ssp-title]');
    var sub = car.querySelector('[data-ssp-sub]');
    var cta = car.querySelector('[data-ssp-cta]');
    var hint = car.querySelector('[data-ssp-hint]');
    var prev = car.querySelector('[data-ssp-prev]');
    var next = car.querySelector('[data-ssp-next]');
    var cards = Array.prototype.slice.call(rail.querySelectorAll('[data-print-val]'));
    var total = cards.length;
    // Inline (in a PDP step) = no toggle row: the step header opens and closes the panel.
    var inline = !toggle;
    var browseTitle = title ? title.textContent : '';
    var closeTimer = null;

    function selected() { return rail.querySelector('[data-print-val][aria-checked="true"]'); }

    function paintArrows() {
      var max = rail.scrollWidth - rail.clientWidth;
      var overflow = max > 2;
      car.classList.toggle('no-overflow', !overflow);
      if (hint) hint.hidden = !overflow;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max - 2;
    }

    // ss-pdp-letter.js swaps the "What's inside" print photo on pick but not its
    // caption ("A3 matte print · Love You More"), so the two disagreed. Rename it here.
    var names = cards.map(function (c) { return c.getAttribute('data-print-val'); });
    function syncInsideCaption(name) {
      var img = document.querySelector('[data-inside-print-img]');
      var tile = img;
      while (tile && !(tile.querySelector && tile.querySelector('.c1-pol-name'))) tile = tile.parentElement;
      var cap = tile && tile.querySelector('.c1-pol-name');
      if (!cap) return;
      Array.prototype.forEach.call(cap.childNodes, function (n) {
        if (n.nodeType !== 3) return;
        names.forEach(function (old) {
          if (old !== name && n.nodeValue.indexOf(old) > -1) n.nodeValue = n.nodeValue.split(old).join(name);
        });
      });
    }

    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -rail.clientWidth * 0.8, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: rail.clientWidth * 0.8, behavior: 'smooth' }); });
    rail.addEventListener('scroll', paintArrows, { passive: true });

    if (inline) {
      // ss-pdp-letter.js marks the card on the button itself; this runs on bubble, after it.
      rail.addEventListener('click', function (e) {
        var card = e.target.closest('[data-print-val]');
        if (!card || card.disabled) return;
        syncInsideCaption(card.getAttribute('data-print-val'));
      });
      // The rail has no width while its step body is hidden (and scrolls back to 0): when it
      // gets one, bring the picked card into view and repaint the arrows.
      var lastW = rail.clientWidth;
      var onSize = function () {
        var w = rail.clientWidth;
        if (w > 0 && lastW === 0) {
          var sel = selected();
          if (sel) rail.scrollLeft = Math.max(0, sel.parentElement.offsetLeft - 4);
        }
        lastW = w;
        paintArrows();
      };
      if (window.ResizeObserver) new ResizeObserver(onSize).observe(rail);
      else window.addEventListener('resize', onSize);
      document.addEventListener('sst:progress', onSize);
      paintArrows();
      return;
    }

    function paintToggle() {
      var sel = selected();
      var open = car.classList.contains('is-open');
      car.classList.toggle('has-print', !!sel);
      if (sel) {
        thumb.querySelector('img').src = sel.getAttribute('data-ssp-thumb-src');
        thumb.hidden = false;
        stack.hidden = true;
        title.textContent = sel.getAttribute('data-print-val');
        sub.textContent = 'Print ' + sel.getAttribute('data-ssp-num') + ' of ' + total + ' · unframed A3';
      } else {
        thumb.hidden = true;
        stack.hidden = false;
        title.textContent = browseTitle;
        sub.textContent = 'Swipe to compare';
      }
      cta.textContent = open ? 'Close' : (sel ? 'Change' : 'Browse');
    }

    function revealSelected() {
      var sel = selected();
      if (!sel) { rail.scrollLeft = 0; return; }
      var wrap = sel.parentElement;
      rail.scrollLeft = Math.max(0, wrap.offsetLeft - 4);
    }

    function setOpen(open, opts) {
      clearTimeout(closeTimer);
      car.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) panel.removeAttribute('inert'); else panel.setAttribute('inert', '');
      if (open) { revealSelected(); paintArrows(); }
      // Viewer "Choose this" hides its own button, leaving focus on <body>: bring it back here too.
      else if (opts && opts.refocus && (panel.contains(document.activeElement) || document.activeElement === document.body)) toggle.focus({ preventScroll: true });
      paintToggle();
    }

    toggle.addEventListener('click', function () { setOpen(!car.classList.contains('is-open')); });

    // ss-pdp-letter.js marks the card on the button itself; this runs on bubble, after it.
    rail.addEventListener('click', function (e) {
      var card = e.target.closest('[data-print-val]');
      if (!card || card.disabled) return;
      syncInsideCaption(card.getAttribute('data-print-val'));
      paintToggle();
      closeTimer = setTimeout(function () { setOpen(false, { refocus: true }); }, 450);
    });

    window.addEventListener('resize', function () { if (car.classList.contains('is-open')) paintArrows(); });

    car.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && car.classList.contains('is-open')) { setOpen(false); toggle.focus(); }
    });

    // The zoom viewer's "Choose this" clicks the card, which lands in the rail handler above.
    paintToggle();
  }

  function boot() { document.querySelectorAll('[data-ssp-car]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
